
import Vue from "vue";
import PopperVue from "@/popper-vue.vue";
import Tooltip from "./tooltip.vue";

const positions = ["top", "right", "bottom", "left"];
export default Vue.extend({
  name: "ServeDev",
  components: {
    PopperVue,
    Tooltip
  },
  data() {
    return {
      showTooltip: true,
      positionCounter: 0,
      showClock: true
    };
  },
  methods: {
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    toggleShowClock() {
      this.showClock = !this.showClock;
    }
  },
  created() {
    setInterval(() => {
      this.positionCounter += 1;
    }, 1000);
  },
  computed: {
    placement(): any {
      return positions[this.positionCounter % 4];
    }
  }
});
